import gql from 'graphql-tag';

export default fields => gql`
query {
  listTasks (filter: null, limit: 100, nextToken: null) {
    items {
      __typename
      ${[...['id', 'name'].concat(fields)]}
    }
  }
}`;

// query {
//   listTasks {


// WEBPACK FOOTER //
// ./src/GraphQueries/BacklogTasks/AllQuery.js